import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return (
      <>
        <footer className='background text-light text-center p-2 mt-2'>
        <p>copyright@newsapp.com</p>
        </footer>
      </>
    )
  }
}

